import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../../../redux/actions/index';
import PickupDetailsForm from '../../../../../component/Inventory/InventoryTicketsComponents/PickupsTicketComponents/PickupDetailsFormComponent/PickupDetailsForm';
import { animateScroll as scroll} from 'react-scroll'
import { routes } from '../../../../../../utility/constants/constants';
const cloneDeep = require('clone-deep');

class PickupDetailsFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pickingTicketId: null,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if(this.props && this.props.match && this.props.match.params && this.props.match.params.ticketId) {
      this.setState({pickingTicketId: this.props.match.params.ticketId})
      this.props.getSinglePickupTicket(this.props.match.params.ticketId);
    };
    scroll.scrollToTop();
  }

  handleSubmit = (values) => {
    let pickedUPItems = cloneDeep(values.pickedUPItems);
    this.props.history.push({
        pathname: routes.INVENTORY_SCAN_READY_FOR_DELIVERY_QR,
        state: { pickedUPItems: pickedUPItems }
    })
  };

  componentWillUnmount() {
    this.props.resetInventoryObjects();
  }

  render() {

    return (
        <PickupDetailsForm
          {...this.props}
          onSubmit={this.handleSubmit}
          pickingTicketId={this.state.pickingTicketId}
        />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.InventoryReducer.isLoading,
    isPickupDetailsFormOpen: state.InventoryReducer.isPickupDetailsFormOpen,
    singlePickupTicket: state.InventoryReducer.singlePickupTicket,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetInventoryObjects: () => dispatch(actions.resetInventoryObjects()),
    getSinglePickupTicket: (id) => dispatch(actions.getSinglePickupTicket(id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PickupDetailsFormContainer);